<template>
  <div class="header row row-custom">
    <img src="../../static/img/Logo_mobile_outline.png" alt="logo" class="logo-header" @click="goToRout('home')" />
    <div class="hamburger" @click="menuMobile()">
      <el-badge :value="counterNuovi" class="item badge-nuovi" :hidden="counterNuovi === 0 || counterNuovi === '0'">
        <icon name="riv-hamburgerMobile" scale="1.5" class="icon"></icon>
      </el-badge>
    </div>

    <div class="select-wrapper" @change="setLanguage()">
      <select v-model="codLang">
        <option v-for="(item, index) in languages" :value="item.value" :key="index">{{ item.label }}</option>
      </select>
    </div>

    <!--<el-select v-model="codLang" @change="setLanguage()">
      <el-option
        v-for="item in languages"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>-->

    <!-- Dialog di modifica Password Temporanea -->
    <el-dialog :title="($t('header.editPwd').toUpperCase())" :visible.sync="showModalPwd" class="el-dialog_mobile"
      :append-to-body="true" custom-class="col-24" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" :style="{ height: contenitoreHeight + 'px' }">

      <el-form class="">
        <div class="form-profilo">
          <div class="elemento row row-custom">
            <div class="my-label col-24 no-padding">
              {{ $t('header.passwordTmp') }}
            </div>
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="pwdForm.oldPwd" type="password" clearable autocomplete="off"></el-input>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-24 no-padding">
              {{ $t('header.passwordNew') }}
            </div>
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="pwdForm.newPwd" type="password" clearable autocomplete="off"></el-input>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-24 no-padding">
              {{ $t('header.passwordRep') }}
            </div>
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="pwdForm.newPwdRep" type="password" clearable
                autocomplete="off"></el-input>
            </div>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="">
        <el-button class="el-button--confirm" @click="changePwd">
          {{ $t('header.btn.salva') }}
        </el-button>
      </span>

    </el-dialog>

    <!-- Dialog di inserimento mail -->
    <el-dialog :title="($t('header.insertMail').toUpperCase())" :visible.sync="showModalEmail" class="el-dialog_mobile"
      :append-to-body="true" custom-class="col-24" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false" :style="{ height: contenitoreHeight + 'px' }">

      <el-form class="">
        <div class="form-profilo">
          <div class="elemento row row-custom" style="height: 130px">
            <div class="my-value col-24 no-padding">
              {{ $t('header.msgMail') }}
            </div>
          </div>

          <div class="elemento row row-custom">

            <div class="my-label col-24 no-padding">
              {{ $t('header.mail') }}
            </div>
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="mailForm.mail" clearable autocomplete="off"></el-input>
            </div>
          </div>
          <div class="elemento row row-custom">
            <div class="my-label col-24 no-padding">
              {{ $t('header.password') }}
            </div>
            <div class="my-value col-24 no-padding">
              <el-input placeholder="" v-model="mailForm.pwd" type="password" clearable autocomplete="off"></el-input>
            </div>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="">
        <el-button class="el-button--confirm" @click="changeMail">
          {{ $t('header.btn.salva') }}
        </el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import { bus } from "./Bus";

export default {
  components: {},
  name: "HeaderMobile",
  i18n: {
    messages: {
      it_IT: {
        header: {
          it_IT: "ITALIANO",
          fr_FR: "FRANCESE",
          es_ES: "SPAGNOLO",
          de_DE: "TEDESCO",
          en_GB: "INGLESE",
          cambioLingua: "Cambio lingua",
          linguaImpostata: "Lingua impostata",
          imposta: "Imposta",
          contattaci: "Contattaci",
          a: "A",
          areeDiLavoro: "Aree di Lavoro",
          oggetto: "Oggetto",
          messaggio: "Messaggio",
          allegato: "Allegato",
          scegli: "Scegli...",
          invia: "Invia",
          datiProfilo: "Profilo Personale",
          nome: "Nome",
          cognome: "Cognome",
          telefono: "Telefono",
          mobile: "Cellulare",
          mail: "Email",
          birthday: "Data di nascita",
          reparto: "Reparto",
          mansione: "Mansione",
          modifica: "Modifica",
          linguaPreferita: "Lingua preferita",
          italia: "Italia",
          francia: "Francia",
          spagna: "Spagna",
          belgio: "Belgio",
          germania: "Germania",
          stato: "Stato",
          editPwd: "Modifica Password",
          passwordTmp: "Password Temporanea",
          passwordNew: "Nuova Password",
          passwordRep: "Conferma Password",
          insertMail: 'Inserimento e-Mail',
          mail: 'E-mail',
          password: 'Password',
          msgMail: "Ai fini di sicurezza, per garantire l'accesso al portale in caso di smarrimento password, è richiesto l'inserimento di un indirizzo email per il suo recupero.",
          btn: {
            salva: "Salva"
          }
        }
      },
      fr_FR: {
        header: {
          it_IT: "ITALIEN",
          fr_FR: "FRANÇAIS",
          es_ES: "ESPAGNOL",
          de_DE: "ALLEMAND",
          en_GB: "ANGLAIS",
          cambioLingua: "Changer la langue",
          linguaImpostata: "Langue choisie",
          imposta: "Configurer",
          contattaci: "Contactez-nous",
          a: "À",
          areeDiLavoro: "Zones de Travail",
          oggetto: "Sujet",
          messaggio: "Message",
          allegato: "Enceinte",
          scegli: "Choisir...",
          invia: "Soumettre",
          datiProfilo: "Données de profil",
          nome: "Nom",
          cognome: "Prénom",
          telefono: "Téléphone",
          mobile: "Téléphone portable",
          mail: "Email",
          birthday: "Date de naissance",
          reparto: "Département",
          mansione: "Emploi",
          modifica: "Changement",
          linguaPreferita: "Langue préférée",
          italia: "Italie",
          francia: "France",
          spagna: "Espagne",
          belgio: "Belgique",
          germania: "Allemagne",
          stato: "Nation",
          editPwd: "Changer le mot de passe",
          passwordTmp: "Mot de passe provisoire",
          passwordNew: "Mot de passe",
          passwordRep: "Confirmer mot de passe",
          insertMail: 'Entrer votre Email',
          mail: 'E-mail',
          password: 'Mot de passe',
          msgMail: "Pour des raisons de sécurité, pour garantir l'accès au portail en cas de perte de mot de passe, il est nécessaire de saisir une adresse e-mail pour sa récupération.",
          btn: {
            salva: "Sauvegarder"
          }
        }
      },
      es_ES: {
        header: {
          it_IT: "ITALIANO",
          fr_FR: "FRANCÉS",
          es_ES: "ESPAÑOLA",
          de_DE: "GERMAN",
          en_GB: "INGLÉS",
          cambioLingua: "Cambiar el idioma",
          linguaImpostata: "Idioma elegido",
          imposta: "Establecer",
          contattaci: "Contáctenos",
          a: "Para",
          areeDiLavoro: "Áreas de Trabajo",
          oggetto: "Sujeto",
          messaggio: "Mensaje",
          allegato: "Anexo",
          scegli: "Elegir...",
          invia: "Enviar",
          datiProfilo: "Datos de perfil",
          nome: "Nombre",
          cognome: "Apellido",
          telefono: "Teléfono",
          mobile: "Teléfono móvil",
          mail: "E-ail",
          birthday: "Fecha de nacimiento",
          reparto: "Departamento",
          mansione: "Trabajo",
          modifica: "Cambio",
          linguaPreferita: "Idioma preferido",
          italia: "Italia",
          francia: "Francia",
          spagna: "España",
          belgio: "Bélgica",
          germania: "Alemania",
          stato: "Estado",
          editPwd: "Es necesario crear una nueva contraseña antes de continuar",
          passwordTmp: "Contraseña temporal",
          passwordNew: "Nueva contraseña",
          passwordRep: "Confirmar contraseña",
          mail: 'E-mail',
          password: 'Contraseña',
          msgMail: "Por seguridad, para garantizar el acceso al portal en caso de perdida de la contraseña, es necesario indicar una dirección de correo electrónico para su recuperación.",
          btn: {
            salva: "Guardar"
          }
        }
      },
      de_DE: {
        header: {
          it_IT: "ITALIAN",
          fr_FR: "FRENCH",
          es_ES: "SPANISCHE",
          de_DE: "DEUTSCH",
          en_GB: "ENGLISCH",
          cambioLingua: "Ändere die Sprache",
          linguaImpostata: "Gewählte Sprache",
          imposta: "Einrichten",
          contattaci: "Kontaktieren Sie uns",
          a: "Zu",
          areeDiLavoro: "Arbeitsbereiche",
          oggetto: "Subjekt",
          messaggio: "Nachricht",
          allegato: "Annektieren",
          scegli: "Wählen...",
          invia: "Einreichen",
          datiProfilo: "Profildaten",
          nome: "Name",
          cognome: "Nachname",
          telefono: "Telefon",
          mobile: "Mobiltelefon",
          mail: "E-ail",
          birthday: "Geburtsdatum",
          reparto: "Abteilung",
          mansione: "Job",
          modifica: "Veränderung",
          linguaPreferita: "bevorzugte Sprache",
          italia: "Italien",
          francia: "Frankreich",
          spagna: "Spanien",
          belgio: "Belgien",
          germania: "Deutschland",
          stato: "Zustand",
          editPwd: 'Bevor weitergehen ist es notwendig ein neues Passwort einzurichten',
          passwordTmp: 'Vorläufiges Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          insertMail: 'Geben Sie Ihre E-Mail ein',
          mail: 'E-Mail',
          password: 'Passwort',
          msgMail: "Um im Falle eines Passwortverlustes den Zugang zum Portal zu gewährleisten, ist aus Sicherheitsgründen die Eingabe einer E-Mail-Adresse für dessen Wiederherstellung erforderlich.",
          btn: {
            salva: 'Gespeichert'
          }
        }
      },
      en_GB: {
        header: {
          it_IT: "ITALIAN",
          fr_FR: "FRENCH",
          es_ES: "SPANISH",
          de_DE: "GERMAN",
          en_GB: "ENGLISH",
          cambioLingua: "Change language",
          linguaImpostata: "Selected language",
          imposta: "Select",
          contattaci: "Contact us",
          a: "To",
          areeDiLavoro: "Work Areas",
          oggetto: "Subject",
          messaggio: "Message",
          allegato: "Attached",
          scegli: "Choose...",
          invia: "Send",
          datiProfilo: "Profile data",
          nome: "Name",
          cognome: "Surname",
          telefono: "Telephone",
          mobile: "Mobile phone",
          mail: "Email",
          birthday: "Date of birth",
          reparto: "Department",
          mansione: "Task",
          modifica: "Change",
          linguaPreferita: "Preferred Language",
          italia: "Italy",
          francia: "France",
          spagna: "Spain",
          belgio: "Belgium",
          germania: "Germany",
          stato: "Country",
          editPwd: 'Bevor weitergehen ist es notwendig ein neues Passwort einzurichten',
          passwordTmp: 'Vorläufiges Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          insertMail: 'Insert your e-Mail',
          mail: 'E-mail',
          password: 'Password',
          msgMail: "For security purposes, to guarantee access to the portal in the event of a lost password, an email address is required for its recovery.",
          btn: {
            salva: 'Save'
          }
        }
      }
    }
  },
  props: {
    contenitoreHeight: {
      type: Number
    }
  },
  data() {
    return {
      utente: "Utente Demo",
      languageDialogVisible: false,
      lingua: "",
      codLang: "",
      contattiDialogVisible: false,
      areeDiLavoro: [],
      areaLavoro: "",
      oggettoMsg: "",
      msg: "",
      uploadList: [],
      username: "",
      ragSoc: "",
      changeUserDataVisible: false,
      form: {
        username: "",
        nome: "",
        cognome: "",
        mail: "",
        preferredLanguage: ""
      },
      swithModifica: false,
      lingue: [
        {
          codLang: "it_IT"
        },
        {
          codLang: "fr_FR"
        },
        {
          codLang: "es_ES"
        },
        {
          codLang: "de_DE"
        },
        {
          codLang: "en_GB"
        }
      ],
      countryContatti: 1,
      contatti: [],
      contatto: "",
      showModalPwd: false,
      pwdForm: {
        oldPwd: "",
        newPwd: "",
        newPwdRep: ""
      },
      showModalEmail: false,
      mailForm: {
        pwd: '',
        mail: ''
      },
      languages: [
        {
          value: 'de_DE',
          label: 'DE'
        },
        {
          value: "es_ES",
          label: "ES"
        },
        {
          value: "fr_FR",
          label: "FR"
        },
        {
          value: "it_IT",
          label: "IT"
        }
      ],
      messaggiCount: {},
      counterNuovi: 0
      /* languages: [{
          value: 'de_DE',
          label: 'DE'
        }, {
          value: 'en_GB',
          label: 'EN'
        }, {
          value: 'es_ES',
          label: 'ES'
        }, {
          value: 'fr_FR',
          label: 'FR'
        }, {
          value: 'it_IT',
          label: 'IT'
        }], */
    };
  },
  computed: {
    checkInvioMsg: function () {
      return !(this.oggettoMsg !== "" && this.msg !== "");
    }
  },
  mounted: function () {
    if (sessionStorage.hasOwnProperty("codLang")) {
      this.codLang = sessionStorage.getItem("codLang")
    }
    /*if (sessionStorage.hasOwnProperty("codLang")) {
      this.$root.$i18n.locale = sessionStorage.getItem("codLang");
      this.codLang = sessionStorage.getItem("codLang");
    } else {
      sessionStorage.setItem("codLang", process.env.codLang);
      this.$root.$i18n.locale = process.env.codLang; // 'fr_FR'
      this.codLang = process.env.codLang; // 'fr_FR'
    }*/
    //this.getUserData();
    if (sessionStorage.getItem('tempPwd') === "SI") {
      this.showModalPwd = true
    } else if (sessionStorage.getItem('reqMail') === 'SI') {
      // Se non dev mostrare la dialog di campio password Temporane verifico se devo forzare l'inserimento della mail
      // Questo per evitare il sovrapporsi delle dialog
      this.showModalEmail = true
    }
    this.$set(this, 'counterNuovi', 0)
    bus.$on('changeMessaggiCount', () => {
      this.$set(this, 'messaggiCount', this.$store.state.messaggiCount)
      this.$set(this, 'counterNuovi', this.$store.state.messaggiCount.totale)
    })
  },
  methods: {
    goToRout: function (rout) {
      this.$router.push({ name: rout })
    },
    menuMobile: function () {
      this.$emit("menuMobile");
    },
    showMessages: function () {
      this.$emit("showMessages");
    },
    setLanguage: function () {
      sessionStorage.setItem("codLang", this.codLang);
      this.$root.$i18n.locale = this.codLang;
      this.languageDialogVisible = false;
      bus.$emit("changeLanguage");
    },
    getUserData: function () {
      this.loading = true;
      this.$http.get("dipendente/" + this.$store.state.country + "/info").then(response => {
        if (response.body.rc === 0) {
          this.$set(
            this,
            "username",
            response.body.data.nomex + " " + response.body.data.cognx
          );
          this.$set(this, "ragSoc", response.body.data.desSoc);
          this.$set(this.form, "nome", response.body.data.nomex);
          this.$set(this.form, "cognome", response.body.data.cognx);
          this.$set(this.form, "mail", response.body.data.email);
          //this.$set(this.form, 'preferredLanguage', response.body.data.preferredLanguage)
        }
      });
    },
    changePwd: function () {
      let correctInput = true
      if (this.pwdForm.oldPwd === '' || this.pwdForm.newPwd === '' || this.pwdForm.newPwdRep === '') {
        correctInput = false
        this.$message({
          message: 'Inserire tutti i dati',
          type: 'error'
        })
      }
      if (this.pwdForm.newPwd != this.pwdForm.newPwdRep) {
        correctInput = false
        this.$message({
          message: 'Le password non coincidono',
          type: 'error'
        })
      }
      if (correctInput) {
        var obj = {
          oldPwd: this.pwdForm.oldPwd,
          newPwd: this.pwdForm.newPwd,
          newPwdRep: this.pwdForm.newPwdRep
        }
        this.$http.post('dipendente/' + this.$store.state.country + '/changePwd', obj, { emulateJSON: true }).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'success'
            })
            this.showModalPwd = false
            sessionStorage.setItem('tempPwd', '')
            sessionStorage.removeItem('tempPwd')
            if (sessionStorage.getItem('reqMail') === 'SI') {
              this.showModalEmail = true
            }
          } else {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'error'
            })
          }
        })
      }
    },
    changeMail: function () {
      this.loading = true
      var obj = {
        mail: this.mailForm.mail,
        pwd: this.mailForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeMail', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
          this.showModalEmail = false
          sessionStorage.setItem('reqMail', '')
          sessionStorage.removeItem('reqMail')
          this.$store.commit('set', { key: 'mail', value: this.mailForm.mail })
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.loading = false
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/general.less";

.dialog-lingua {
  height: auto;
}

.dialog-contattaci {
  height: auto;
}

.el-dialog_mobile {
  .el-dialog {
    .set-font();
    border-radius: 0px;
    margin-top: 60px !important;
    margin-bottom: 0px !important;
    height: calc(100% - 60px);

    .el-dialog__close {
      color: @greenRiva;
    }

    .el-dialog__header {
      padding: 7px 0px 2px 0px;
      border-bottom: 1px solid @greenRiva;
      width: 100%;
      line-height: 0px;
      margin: auto;

      .el-dialog__title {
        .set-font(@size: 14px; @weight: bold; @color: @greenRiva);
      }

      .el-dialog__headerbtn {
        top: 10px;
        right: 3%;
      }
    }

    .el-dialog__body {
      padding: 40px 20px;
      padding-right: 0px;
      padding-left: 0px;
      padding-bottom: 0px;
      margin: auto;
      width: 100%;

      .el-form {
        .row-custom {
          height: 60px;
          margin-bottom: 20px;

          .my-area {
            margin-bottom: 10px;
            height: 20px;
            border-bottom: 1px solid @oroRiva;
            color: @oroRiva;
            font-weight: bold;
          }

          .my-label {
            height: 30px;
            line-height: 30px;
            font-style: italic;
            .set-font(@size: 16px; @color: @greenRiva);

            .el-checkbox {
              float: right;
              margin-bottom: 0px;

              //margin-top: 10px;
              .el-checkbox__inner {
                border-radius: 0px;
              }

              &.is-checked {
                .el-checkbox__inner {
                  background-color: @greenRiva;
                  border-color: @greenRiva;
                }
              }
            }

            &.trasp {
              margin-bottom: 10px;
            }
          }

          .my-value {
            height: 30px;
            line-height: 30px;

            .el-input {
              .set-font(@size: 16px; @color: @grayMedium);

              &.is-disabled {
                .el-input__inner {
                  border: none;
                }
              }

              .el-input__inner {
                border: none;
                border-bottom: 1px solid #dcdfe6;
                border-radius: 0px;
                height: 22px;
                padding-left: 0px;
                line-height: 0px;
                .set-font(@size: 16px);
                color: @grayMedium;
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }
            }

            .el-date-editor--time {
              width: 150px !important;
            }

            .el-select {
              height: 22px;
              width: 100%;

              .el-input {
                height: 22px;

                .el-input__inner {
                  border: none;
                  border-bottom: 1px solid #dcdfe6;
                  border-radius: 0px;
                  height: 22px !important;
                  padding-left: 0px;
                  .set-font(@size: 14px);
                  color: @grayMedium;

                }
              }
            }

            .el-textarea {
              .el-textarea__inner {
                border-radius: 0px;
                padding-left: 5px;
                line-height: 22px;
                color: @grayMedium;
              }

              .el-textarea__inner:focus {
                border-color: @greenRiva;
              }
            }

            &.trasp {
              margin-bottom: 10px;
            }

            .el-range-editor {
              width: 100%;

              &.el-input__inner {
                border: 0;
                border-bottom: 1px solid #dcdfe6;
                border-radius: 0px;
                height: 22px;
                padding-left: 0px;
                padding-right: 0px;
                line-height: 0px;
                .set-font(@size: 14px);
                color: #007c74;
              }

              .el-input__icon {
                line-height: 16px;
                width: 28px;
              }

              .el-range-input {
                color: #007c74;
              }

              .el-range-separator {
                color: @grayMedium;
                line-height: 18px;
                width: auto;
              }
            }

            .el-date-editor {
              width: 100%;

              .el-input__inner {
                padding-left: 30px !important;
              }

              .el-input__prefix {
                left: 0px;

                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              .el-input__suffix {
                .el-input__icon {
                  line-height: 22px;
                  width: 17px;
                }
              }

              &.time {
                width: 100px;
              }
            }
          }
        }
      }
    }

    .el-dialog__footer {
      height: 80px;
      padding: 10px 0px 20px 0px;

      .el-button--abort {
        text-transform: uppercase !important;
        letter-spacing: 3px !important;
        border: 1px solid @oroRiva !important;
        background-color: @white !important;
        font-family: "os-regular" !important;
        font-weight: normal !important;
        font-size: 16px !important;
        float: right !important;
        color: @oroRiva !important;
        border-radius: 0px !important;
        -webkit-box-shadow: 3px 3px 4px @grayLight !important;
        box-shadow: 3px 3px 4px @grayLight !important;
        margin-right: 10px !important;
        margin-bottom: 20px !important;
        margin-top: 10px !important;
        padding: 8px 12px !important;
        height: 35px !important;
      }

      .el-button--abort:hover {
        background-color: lighten(@oroRiva, 30%) !important;
      }

      .el-button--confirm {
        text-transform: uppercase !important;
        letter-spacing: 3px !important;
        border: 1px solid @oroRiva !important;
        background-color: @oroRiva !important;
        font-family: "os-regular" !important;
        font-weight: normal !important;
        font-size: 16px !important;
        float: right !important;
        color: @white !important;
        border-radius: 0px !important;
        -webkit-box-shadow: 3px 3px 4px @grayLight !important;
        box-shadow: 3px 3px 4px @grayLight !important;
        margin-right: 10px !important;
        margin-bottom: 20px !important;
        margin-top: 10px !important;
        padding: 8px 12px !important;
        height: 35px !important;
      }

      .el-button--confirm:hover {
        background-color: darken(@oroRiva, 15%) !important;
      }
    }

    .form-dettaglio {
      margin-bottom: 20px;

      .modifica {
        margin-bottom: 40px !important;
      }

    }
  }
}

.header {
  display: block;
  text-align: left;
  background-color: #007c74;
  font-size: 0;
  padding: 10px 10px;

  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  .select-wrapper {
    float: right;
    width: 40px;
    height: 36px;
    padding-top: 2px;
    background-color: transparent;
    display: inline-block;

    select {
      padding-left: 6px;
      background-color: transparent;
      height: 36px;
      width: 100%;
      border-radius: 0px;
      border: none;
      border-left: 1px solid #fff;
      font-size: 18px;
      text-align: center;
      color: #fff;
      -webkit-appearance: none;
      outline: none;

      option {
        color: #000;
      }

      &:focus {
        outline: none;
      }
    }
  }

  /*
  .el-select {
    float: right;
    width: 40px;
    // padding-top: 12px;
    .el-input {
      input {
        background-color: transparent;
        .set-font(@weight: 300, @size: 18px, @color: #fff);
        padding-right: 0;
        border: none;
        border-left: 1px solid #fff;
        border-radius: 0px;
      }
    }
    .el-input__suffix {
      display: none;
    }
  }
  */
  .hamburger {
    float: right;
    width: 40px;

    .el-badge__content {
      height: 22px;
      width: 22px;
      border-radius: 50%;
      line-height: 17px;
      padding: 1px 0px;
      text-align: center;
      font-family: "os-regular";
      font-weight: normal;
      font-size: 11px;
      color: #ffffff;
      background-color: red;

      &.is-fixed {
        top: 8px;
        right: 10px;
      }
    }

    .icon {
      margin-top: 8px;
      float: right;
      color: #fff;
    }
  }

  .el-select-dropdown__list {
    background-color: rgba(245, 245, 245, 1);

    :hover {
      background-color: #f6f5f5;
    }

    .el-select-dropdown__item {
      .set-font(@weight: 300, @size: 18px, @color: #000);
      border-bottom-color: #f6f5f5;
    }
  }

  .el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderAppMobile.vue